export const environment = {
    production: true,
    apiUrl: 'https://reinsurance-api.icz.co.zw:8445',
    reinsuranceApiUrl: 'https://reinsurance-api.icz.co.zw:8445',
    tokenKey: '',
    userPermissionsKey: 'user_permissions',
    recaptcha: {
        clientKey:'6LckJlwrAAAAALpItVmkwcQ0Aj4oJi_TZHceQany',
        serverKey: '6LckJlwrAAAAAHbv-9Rf-tvhtlGyXZrDGl7jjO6T',
    },
    CI: true,

};


